import React, {FC} from "react";
import {SkillType} from "../../store/reducer";


export const Skill:FC<{item:SkillType}> = React.memo(({item}) => {
    return <div className={'skills_item'}>
        <img src={item.image} alt=""/>
        <h2>{item.name}</h2>
    </div>
})